<template>
    <el-form :model="signInForm" label-width="120px">
        <el-row :gutter="20">
            <el-col :span="8">
                <el-form-item label="运输单号：">
                    <div class="inputValue">
                        {{ signInForm.taskNo }}
                    </div>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="客户订单号：">
                    <div class="inputValue">
                        {{ signInForm.customerOrderNo }}
                    </div>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="8">
                <el-form-item label="网点名称：">
                    <div class="inputValue">
                        {{ signInForm.networkName }}
                    </div>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="网点联系方式：">
                    <div class="inputValue">
                        {{ networkContact }}
                    </div>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="网点签收时间：">
                    <div class="inputValue">
                        {{ signInForm.networkSignTime }}
                    </div>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="8">
                <el-form-item label="网点详细地址：">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="signInForm.networkAddr"
                        placement="top-start"
                    >
                        <div class="inputValue">
                            {{ signInForm.networkAddr }}
                        </div>
                    </el-tooltip>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="8">
                <el-form-item label="用户名称：">
                    <div class="inputValue">
                        {{ signInForm.finalName }}
                    </div>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="用户联系方式：">
                    <div class="inputValue">
                        {{ receiverContact }}
                    </div>
                </el-form-item>
            </el-col>
            <el-col :span="8">
                <el-form-item label="用户签收时间：">
                    <div class="inputValue">
                        {{ signInForm.receiverSignTime }}
                    </div>
                </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="8">
                <el-form-item label="用户详细地址：">
                    <el-tooltip
                        class="item"
                        effect="dark"
                        :content="signInForm.finalDetailAddr"
                        placement="top-start"
                    >
                        <div class="inputValue">
                            {{ signInForm.finalDetailAddr }}
                        </div>
                    </el-tooltip>
                </el-form-item>
            </el-col>
        </el-row>
    </el-form>
</template>
<script>
export default {
    name: 'signInForm',
    data () {
        return {
            signInForm: {
                taskNo: '', // 运输单号
                customerOrderNo: '', // 客户订单号
                networkName: '', // 网点名称
                networkContact: '', // 网点联系人
                networkTel: '', // 网点联系方式
                networkPhone: '', // 网点联系手机
                networkSignTime: '', // 网点签收时间
                networkAddr: '', // 网点详细地址
                finalName: '', // 用户名称
                finalMobile: '', // 用户联系方式
                finalTel: '', // 用户固定电话
                receiverSignTime: '', // 用户签收时间
                finalDetailAddr: '' // 用户详细地址
            }
        };
    },
    computed: {
        // 网点联系方式
        networkContact () {
            if (this.signInForm.networkContact && this.signInForm.networkTel && this.signInForm.networkPhone) {
                return this.signInForm.networkContact + '/' + this.signInForm.networkPhone + '/' + this.signInForm.networkTel;
            } else if (this.signInForm.networkContact && (this.signInForm.networkTel || this.signInForm.networkPhone)) {
                return this.signInForm.networkContact + '/' + this.signInForm.networkTel || this.signInForm.networkPhone;
            } else {
                return this.signInForm.networkTel || this.signInForm.networkPhone;
            }
        },
        // 用户联系方式
        receiverContact () {
            if (this.signInForm.finalName && this.signInForm.finalMobile && this.signInForm.finalTel) {
                return this.signInForm.finalName + '/' + this.signInForm.finalMobile + '/' + this.signInForm.finalTel;
            } else if (this.signInForm.finalName && (this.signInForm.finalMobile || this.signInForm.finalTel)) {
                return this.signInForm.finalName + '/' + this.signInForm.finalMobile || this.signInForm.finalTel;
            } else {
                return this.signInForm.finalMobile || this.signInForm.finalTel;
            }
        }
    },
    methods: {
        /**
         * @description 初始化用户签收详情表单字段值
         * @param {Object} data 接口返回的回单数据
         */
        initFormData (data) {
            Object.keys(this.signInForm).forEach(k => {
                this.signInForm[k] = data[k] || '';
            });
        }
    }
};
</script>
